import {Anchor} from '@mantine/core';
import classes from './anchor.module.css';

export const AnchorTheme = Anchor.extend({
  classNames: classes,
});